import { render, staticRenderFns } from "./UserGroupActions.vue?vue&type=template&id=28cf2d74"
import script from "./UserGroupActions.vue?vue&type=script&lang=js"
export * from "./UserGroupActions.vue?vue&type=script&lang=js"
import style0 from "./UserGroupActions.vue?vue&type=style&index=0&id=28cf2d74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports